
import { useReadLocationTipsQuery } from 'entities/locationTips/api/locationTipsApi'
import styles from './LocationSearchHistory.module.css'

interface LocationSearchHistoryProps {
    onHistoryItemSelect?: (event: any) => void
}

export const LocationSearchHistory = (props: LocationSearchHistoryProps): JSX.Element => {
    const {
        onHistoryItemSelect
    } = props

    const {
        data: readLocationTipsData,
        isLoading: readLocationTipsIsLoading
    } = useReadLocationTipsQuery(undefined)

    const handleHistoryItemClick = (readLocationTip: any) => {
        onHistoryItemSelect?.(readLocationTip)
    }

    const renderHistoryList = (): JSX.Element => {
        if (readLocationTipsIsLoading === true) {
            return (
                <h2>Loading</h2>
            )
        }

        if (readLocationTipsData?.list?.length === 0 ){
            return (
                <div className={styles.History__EmptyHistory}>
                    <h2>No History Yet</h2>
                </div>
            
            )
        }

        return (
            <ul className={styles.History__List}>
                {
                    readLocationTipsData?.list?.map((readLocationTip: any, index: number) => {
                        return (
                            <li className={styles.History__Item}
                                onClick={() => handleHistoryItemClick(readLocationTip)}
                                key={index}
                            >
                                <div className={styles.History__SearchRequest}>
                                    {readLocationTip.name}
                                </div>
                            </li>
                        )
                    }) 
                }
            </ul>
        )
    }

    return (
        <div className={styles.History}>
            <h2 className={styles.History__Heading1}>History</h2>
            {renderHistoryList()}        
        </div>
    )
}